/**
 * The CRM viewer's two request headers (plan ruling 29, spec S1). BROWSER-SAFE:
 * no imports at all.
 *
 * A Cova staff member looking at one firm through `/super-admin/crm-viewer`
 * sends the firm in `x-cova-view-org` and, for See as, the member's Clerk id in
 * `x-cova-view-as`. The names live here, beside `PLATFORM_SCOPE_HEADER`,
 * because two sides need them and neither may import the other: the browser's
 * view-as store writes them, and the server's admission module
 * (`src/presentation/shared/view-as-admission.ts`) is the ONE reader. A third
 * reader is refused by `bms-view-as-header-ratchet.test.ts`.
 *
 * A CLAIM, NEVER AN AUTHORITY. Nothing is admitted because a header is set: the
 * session middleware's staff branch admits the claim only for a caller holding
 * `orgs.read`, and refuses a write route whatever the caller holds. The proxy
 * leaves both on the request; they are never on its strip list, because a
 * broker who sends them is refused, not ignored.
 */

/** The viewed firm's organisation id, a UUID. Absent means no view: the broker path. */
export const VIEW_AS_ORG_HEADER = "x-cova-view-org"

/** The See as member's Clerk id. Absent means the firm administrator's view. Never sent without the firm. */
export const VIEW_AS_MEMBER_HEADER = "x-cova-view-as"
